import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '@shared/components/toastr/toastr-success.component';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';
import { Référentiel } from '../../models/référentiel.model';
import { ReferentielStore } from '../../store/referentiel.store';
import { FormControlNames } from '../referentiels-form.component';

@Component({
  selector: 'app-referentiel-form',
  imports: [HlmFieldImports, ReactiveFormsModule, LabelRequiredDirective, HlmInputImports],
  templateUrl: './référentiel-form.component.html',
})
export class RéférentielFormComponent implements OnInit {
  readonly #store = inject(ReferentielStore);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #fb = inject(FormBuilder);

  readonly referentiel = input.required<Référentiel>();

  form = this.#fb.group({
    [FormControlNames.NOM]: [null, [Validators.required]],
  });

  constructor() {
    effect(() => this.nom.setValue(this.referentiel().nom));
  }

  ngOnInit(): void {
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  onSubmit() {
    const toastrId = uuidv7();

    if (this.form.invalid) return;

    const referentiel = this.referentiel();
    const nom = this.nom.value;

    this.#store.modifier({
      id: referentiel.id,
      data: { nom },
      next: () => {
        toast.custom(ToastrSuccessComponent, {
          componentProps: {
            message: `Modification du référentiel ${nom} réussie`,
            id: toastrId,
          },
          id: toastrId,
        });
        this.#sidepanelService.close();
      },
    });
  }

  get nom() {
    return this.form.get(FormControlNames.NOM) as AbstractControl;
  }
}
